/**
 * OperationalEquipmentSection - Extracted from StepSystems for file size management
 * Handles optional operational equipment selection
 */

import React from 'react';
import { Settings } from 'lucide-react';
import WizardSection from '../../WizardSection';
import { operationalEquipmentOptions } from '../utils/systemsEquipmentData';

const OperationalEquipmentSection = ({ 
  draftConfig, 
  renderEquipmentOption 
}) => {
  return (
    <WizardSection.Card>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="bg-gray-100 p-2 rounded-lg">
            <Settings className="w-5 h-5 text-gray-600" />
          </div>
          <div>
            <WizardSection.Header level="h2">Operational Equipment</WizardSection.Header>
            <p className="text-sm text-gray-600 mt-1">Optional equipment for operational enhancement - no WBC3 requirement</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">
            {(draftConfig.operationalEquipment || []).length} of {operationalEquipmentOptions.length} selected
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {operationalEquipmentOptions.map(option => 
          renderEquipmentOption(option, 'operationalEquipment')
        )}
      </div>
      <WizardSection.Callout variant="info" title="Operational Equipment">
        These equipment items are not required by WBC3 regulations but may enhance operational efficiency and safety.
      </WizardSection.Callout>
    </WizardSection.Card>
  );
};

export default OperationalEquipmentSection;